<template>
  <b-modal
    ref="my-modal"
    :id="idModal"
    size="md"
    centered
    :hide-header="true"
    :hide-footer="true"
    content-class="p-2 atm-rounded"
    no-close-on-backdrop
  >
    <div class="d-flex flex-column align-items-center position-relative w-100">
      <section class="elevation">
        <h1 class="position-relative text-uppercase font-weight-bold">
          YOU DID IT!
        </h1>
        <h4 class="position-relative mb-5">You have a new reward</h4>
      </section>
      <div class="position-relative gap-2 d-flex flex-column align-items-center w-100">
        <div class="reward-container position-relative d-flex justify-content-center">
          <div class="background-image position-absolute">
            <img :src="require('@/assets/bg-congrats.png')" />
          </div>

          <section
            class="elevation position-relative w-100 d-flex flex-column align-items-center m-4"
          >
            <figure class="reward-image w-100">
              <img :src="rewardImg" :alt="rewardName" />
            </figure>
            <section class="d-flex flex-column align-items-center">
              <h2 class="font-weight-bolder">
                {{ rewardName }}
              </h2>
              <h4 class="font-weight-bolder">Keep it up!</h4>
            </section>
          </section>
        </div>
      </div>
      <div class="position-relative d-flex flex-column w-100 mt-2">
        <button @click="hideModal" class="atm-button bg-main mx-auto text-uppercase w-75">
          Continue
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    idModal: {
      type: String,
      default: 'redeem-modal',
    },
    rewardName: {
      type: String,
      default: '',
    },
    rewardImg: {
      type: String,
      default: '',
    },
  },
  methods: {
    hideModal() {
      this.$emit('onClose', true);
      this.$bvModal.hide(this.idModal);
    },
  },
};
</script>

<style lang="scss" scoped>
.elevation {
  z-index: 1;
}
.reward-container {
  width: 100%;
  height: 100%;

  & .reward-image {
    width: 200px;
    height: 200px;
    & > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.background-image {
  top: -24vh;
  & > img {
    width: 50rem;
    height: 50rem;
    object-fit: cover;
  }
}
</style>
